import { useState, useEffect } from "react";
import { IoTrashSharp } from "react-icons/io5";
import appHelpers from "../../../common/helpers/appHelpers";
const FormFiltersShortList = ({
  formValues,
  fields,
  initialValues,
  callback,
  clearFilter
}) => {
  const [filters, setFilters] = useState([]);
  var platform = appHelpers.getPlatform();
  useEffect(() => {
    let newFilters = [];
    for (const fieldValue in formValues) {
      let field = fields.filter((field) => field.key === fieldValue)[0];
      let value = "";
      if (field) {
        if (typeof formValues[fieldValue] === "object") {

          if (fieldValue == "amountRange") {
            var startVal = formValues[fieldValue]["start"];
            var endVal = formValues[fieldValue]["end"];
            if ((startVal && parseFloat(startVal) > 0) || (endVal && parseFloat(endVal) > 0)) {
              value = startVal + " - " + endVal;
            }
          } else {
            for (const formValuefield in formValues[fieldValue]) {
              if (value !== "") value += "-";
              if (field.datatype === "daterange") {
                var dateValue = formValues[fieldValue][formValuefield];
                if ((dateValue instanceof Date)) {
                  value += dateValue.toLocaleDateString();
                }

              } else {
                if (field.type == "") {

                }
                if (typeof formValues[fieldValue][formValuefield] === "object") {
                  value += formValues[fieldValue][formValuefield]?.label;
                } else {
                  value += formValues[fieldValue][formValuefield];
                }
              }
            }
          }
        }
        var isBlankSelect = false;
        if ((field.type == "select" && formValues[fieldValue] <= 0) || (fieldValue == "sendTypeId" && formValues[fieldValue] == 3)) {
          if (platform = "NETSIS" && (fieldValue == "currencyType" && formValues[fieldValue] == 0)) {
            isBlankSelect = false;
          } else
            isBlankSelect = true;
        }

        if (isBlankSelect) {

        } else
          newFilters.push({
            key: field.key,
            label: field?.label,
            value:
              typeof formValues[fieldValue] === "object"
                ? value
                : formValues[fieldValue],
          });
      }
    }

    setFilters([...newFilters]);
  }, [formValues]);

  const deleteFilter = ({ key }) => {
    setFilters(filters.filter((item) => item.key !== key));
    let newFormValues = { [key]: initialValues[key] };
    callback(newFormValues);
  };

  var filterCount = 0;

  return (
    <div className="border-contrast-20 rounded border  leading-3 p-1 px-2 grid grid-cols-12 gap-2">
      <div className="flex flex-row justify-start items-center text-base flex-wrap col-span-10">
        {filters.map((item, index) => {
          var isFiltered = item.value?.toString().length > 0;
          if (isFiltered) {
            filterCount++;
          }
          return (
            isFiltered ? (
              <div key={index} className="bg-contrast-5 p-1 rounded mr-1 mt-1 ">
                <div className="text-contrast-90 flex flex-row flex-nowrap">
                  <span className="text-contrast-70 font-normal	">
                    {item?.label}
                  </span>
                  <span className="px-1">:</span>
                  <span className="text-contrast-90 font-medium ">
                    {fields.find((option) => option.key === item.key).type ===
                      "select"
                      ? fields
                        .find((option) => option.key === item.key)
                        .options.find(
                          (option) => option.value === formValues[item.key]
                        )?.label
                      : typeof item.value === "boolean"
                        ? item.value
                          ? "Evet"
                          : "Hayır"
                        : item.value}
                  </span>
                  <span
                    onClick={() => {
                      deleteFilter(item);
                    }}
                    className="ml-2 font-bold text-contrast-70"
                  >
                    <img
                      className="h-3.5 w-3.5"
                      src="/icons/cross.svg"
                      alt="cross"
                    />
                  </span>
                </div>
              </div>
            ) : null
          )
        })}
        {
          filterCount == 0 ? (
            <div className="text-gray-500 p-1">
              Herhangi bir filtre uygulamadınız
            </div>
          ) : null
        }
      </div>
      {filterCount > 0 ? (
        <a
          className="col-span-2 flex flex-row flex-nowrap justify-end items-center text-base font-bold text-contrast-90 mr-2 hover:text-contrast-70 cursor-pointer "
          onClick={() => {
            clearFilter();
          }}
        >
          <IoTrashSharp
            height={14}
            width={14}
            className="block"
            aria-hidden="true"
          />
          <span>Tümünü temizle</span>
        </a>
      ) : null}

    </div>
  );
};

export default FormFiltersShortList;
